module.exports = __webpack_public_path__ + "static/media/about.567fe43f.svg";